export default __webpack_public_path__ + "static/media/eCommerceApi.15b1f9fa.yaml";